export function UnassignUser(props: any) {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1395 3.31354C15.5297 0.761831 11.4122 0.23989 8.28056 2.15367C7.99059 2.32765 7.9326 2.73361 8.04859 2.96558C8.22257 3.19756 8.57053 3.31354 8.8605 3.13956C11.5282 1.51575 15.1238 1.97969 17.3275 4.18344C18.6614 5.4593 19.3573 7.19911 19.3573 8.9969C19.3573 10.7947 18.6034 12.5345 17.3275 13.8104C15.0078 16.1301 11.3542 16.4781 8.62852 14.6223C8.33855 14.4483 7.99059 14.5063 7.81661 14.7962C7.64263 15.0862 7.70063 15.4342 7.99059 15.6082C9.38244 16.5361 10.9483 17 12.5141 17C14.5439 17 16.5736 16.2461 18.1395 14.6803C19.6473 13.1144 20.4592 11.1427 20.4592 8.9969C20.4592 6.85114 19.6473 4.82137 18.1395 3.31354Z"
        fill={props.color || "#E47363"}
        stroke={props.color || "#E47363"}
        stroke-width="0.5"
      />
      <path
        d="M12.5169 9.57784C12.8648 9.57784 13.0968 9.34586 13.0968 8.9979C13.0968 8.64994 12.8648 8.41797 12.5169 8.41797H10.951C10.6031 8.41797 10.3711 8.64994 10.3711 8.9979C10.3711 9.34586 10.6031 9.57784 10.951 9.57784H12.5169Z"
        fill={props.color || "#E47363"}
        stroke={props.color || "#E47363"}
        stroke-width="0.5"
      />
      <path
        d="M2.97199 9.57578H7.61147C7.95943 9.57578 8.19141 9.3438 8.19141 8.99584C8.19141 8.64788 7.95943 8.41591 7.61147 8.41591H2.97199L5.5817 5.8062C5.81367 5.57423 5.81367 5.22627 5.5817 4.99429C5.34973 4.76232 5.00177 4.76232 4.76979 4.99429L1.1742 8.58989C1.05821 8.70588 1.00022 8.82186 1.00022 8.99584C1.00022 9.16982 1.05821 9.28581 1.1742 9.4018L4.76979 12.9974C4.88578 13.1134 5.00177 13.1714 5.17575 13.1714C5.34973 13.1714 5.46571 13.1134 5.5817 12.9974C5.81367 12.7654 5.81367 12.4175 5.5817 12.1855L2.97199 9.57578Z"
        fill={props.color || "#E47363"}
        stroke={props.color || "#E47363"}
        stroke-width="0.5"
      />
    </svg>
  );
}
